/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { addTransparency } from '@btime/helpers'
import { css } from '@emotion/react'
import { identity } from 'ramda'
import { useClickOutside, useKeydown } from '@btime/react-hooks'
import React from 'react'

import Menu, { MenuItem } from './Menu'
import Panel from '../structure/Panel'

const ModalMenu = ({ children, options, open, onClose, t }) => {
  t = t || identity

  const wrapperRef = React.useRef()
  useClickOutside(wrapperRef, { action: onClose, condition: !!onClose })
  useKeydown(wrapperRef, { keys: ['Escape'], action: onClose || (() => {}) })

  if (!open) return false

  const style = css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #00000070;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    z-index: 1200;

    & .menu {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
  `

  const wrapOnClick = action => () => {
    action && action()
    onClose()
  }

  return (
    <div css={style} className="modalMenu">
      <div ref={wrapperRef} className="modalMenuWrapper">
        <Panel noPadding flex={0} wrapOn="none">
          <Menu>
            {(options || []).map(option => (
              <MenuItem
                key={option.label}
                t={t}
                justify="center"
                withLine
                {...option}
                onClick={wrapOnClick(option.onClick)}
                icon={false}
              />
            ))}
            {children}
          </Menu>
        </Panel>

        <Panel noPadding flex={0} wrapOn="none" bgColor={addTransparency(COLORS.white)}>
          <Menu>
            <MenuItem t={t} label="cancel" justify="center" onClick={onClose} />
          </Menu>
        </Panel>
      </div>
    </div>
  )
}

export default ModalMenu
